import { render } from "./buy-certificate-result.vue?vue&type=template&id=140fbd7d"
import script from "./buy-certificate-result.vue?vue&type=script&lang=js"
export * from "./buy-certificate-result.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__